import { Component, OnInit } from '@angular/core';

import { DgService } from '../../service/dg.service';
import { Experiencia } from '../../models/experiencia';
import { Router } from '@angular/router';

@Component({
  selector: 'app-graphic-design',
  templateUrl: './graphic-design.component.html',
  styleUrls: ['./graphic-design.component.css']
})
export class GraphicDesignComponent implements OnInit {
  dgs: Array<Experiencia> = new Array<Experiencia>();

  constructor(private disenografico: DgService, private Ruta: Router) { }

  ngOnInit(): void {
    this.disenografico.getDg()
    .subscribe(resp => {
      for (const data of resp.body) {
        this.dgs.push(data);
      }
    });
  }

  irADetalle(experiencia: Experiencia) {
    this.disenografico.disenoGrafico = experiencia;
    this.Ruta.navigateByUrl('/detail-graphic-design/' + this.disenografico.disenoGrafico.tituloProyecto);
  }

}
